var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.468,
    height: 35.467,
    viewBox: "0 0 35.468 35.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 35.468,
    height: 35.467,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_616",
    "data-name": "Groupe 616",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_618",
    "data-name": "Groupe 618",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_546",
    "data-name": "Trac\\xE9 546",
    d: "M17.734,35.467A17.734,17.734,0,1,0,0,17.734,17.734,17.734,0,0,0,17.734,35.467",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_547",
    "data-name": "Trac\\xE9 547",
    d: "M20.814,17.271l-5.807,3.41v-6.82Zm5.424,3.161v-6.34a2.993,2.993,0,0,0-3.057-3.056H11.559A2.992,2.992,0,0,0,8.5,14.092v6.34a2.993,2.993,0,0,0,3.055,3.056H23.181a2.994,2.994,0,0,0,3.057-3.056",
    transform: "translate(0.363 0.471)",
    fill: "#015289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.df4ece1abb37ead916c97015f3fc34e5.svg";
export { ForwardRef as ReactComponent };